import { render, staticRenderFns } from "./shonaliSheba.vue?vue&type=template&id=342e9054&"
import script from "./shonaliSheba.vue?vue&type=script&lang=js&"
export * from "./shonaliSheba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports